export default __webpack_public_path__ + "static/media/about3.791e20d7.jpg";